module.exports = __webpack_public_path__ + "img/BK logo--02.af7989a1.jpg";